














































































import Vue, { VueConstructor } from "vue";
import wizardStepsMixin, {
  WizardMixin,
} from "@/components/mixins/wizardStepsMixin";
import validationMixin from "@/components/mixins/validationMixin";
import VaCard from "@/components/molecules/VaCard.vue";
import PresentationStandalone from "@/components/molecules/presentationOptions/PresentationStandalone.vue";
import PresentationByomDongle from "@/components/molecules/presentationOptions/PresentationByomDongle.vue";
import PresentationByomNoDongle from "@/components/molecules/presentationOptions/PresentationByomNoDongle.vue";
import tenantService from "@/services/tenantService";

export default (Vue as VueConstructor<WizardMixin>).extend({
  name: "PresentationSetupSelector",
  mixins: [wizardStepsMixin, validationMixin],
  data() {
    return {
      presentationSetup: this.value,
    };
  },
  props: {
    value: {
      type: Number,
      required: false,
      default: 1,
    },
  },
  components: {
    VaCard,
    PresentationStandalone,
    PresentationByomDongle,
    PresentationByomNoDongle,
  },
  computed: {
    isMainTenant(): boolean {
      return tenantService.isMainTenant();
    },
  },
  watch: {
    value: function (newVal) {
      this.presentationSetup = newVal;
    },
    presentationSetup: function (newVal) {
      this.$emit("change", newVal);
    },
  },
});
